/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import normalizeCss from 'normalize.css';
import s from './Layout.css';
import s2 from './Layout.sass';
import history from '../../history';
import OrderingHeader from '../Header/OrderingHeader';
import OrderingFooter from '../Footer/OrderingFooter';
import { setLocale, setIsdefaultLang } from '../../actions/intl';

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    currentLocale: PropTypes.string.isRequired,
    defaultLocale: PropTypes.string.isRequired,
    setLocale: PropTypes.func.isRequired,
    isDefaultLang: PropTypes.bool.isRequired,
    setIsdefaultLang: PropTypes.func.isRequired,
    showHeader: PropTypes.bool,
    showFooter: PropTypes.bool,
  };

  static defaultProps = {
    showHeader: true,
    showFooter: true,
  };

  constructor(props) {
    super(props);
    // ensure lang is not zh-CN
    this.state = {
      pathname: '',
      isValidEnter: false,
      lang: props.currentLocale.split('-')[1].toLowerCase(),
      modelDataText: null,
      needToRedirect: false,
      locale: props.defaultLocale,
      fileLang: `${
        props.currentLocale.split('-')[0]
      }_${props.currentLocale.split('-')[1].toLowerCase()}/`,
    };
  }
  componentWillMount() {
    // ensure current lang equals to default lang
    /*
    Due to using react-intl plugin (base on the requirement), this may need switch twice to change languages.
    The plugin store the using languages to cookie. To ensure the using language is correct, it will reload the page to do it.
    */
    if (
      this.props.currentLocale.split('-')[1] !==
      this.props.defaultLocale.split('-')[1]
    ) {
      const { locale } = this.state;
      this.props.setLocale({ locale });
      this.setState({ needToRedirect: true });
    }
  }

  componentDidMount() {
    if (
      new Date('2022-07-06T00:00:00+08:00') <= new Date() &&
      this.state.locale === 'zh-TW'
    ) {
      // TW service is going to shutdown on 06Jul2022.
      window.location.href = 'https://www.gogox.com/tw/';
    }

    if (this.state.needToRedirect) {
      const { locale } = this.state;
      this.props.setLocale({ locale });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else {
      this.props.setIsdefaultLang(true);
    }
    // ensure not in zh-CN
    if (this.props.currentLocale === 'zh-CN') {
      this.props.setLocale({ locale: this.props.defaultLocale });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else {
      this.setCurrentLocate();
    }
    document.body.classList.add(`${s2.adjustPaddingRight}`);
  }

  setCurrentLocate() {
    const { lang, fileLang } = this.state;
    this.setState({
      modelDataText: require(`../../assets/json/${lang}/${
        lang === 'hk' ? fileLang : ''
      }setting/index/locale.json`),
    });
    this.setState({ isValidEnter: true });
    this.setState({
      pathname: history.location.pathname.replace('/', '').toLowerCase(),
    });
  }

  render() {
    const { showHeader, showFooter } = this.props;

    if (this.state.isValidEnter && this.props.isDefaultLang) {
      return (
        <div>
          <Helmet>
            {/* set website title */}
            <title>{this.state.modelDataText.title}</title>
            <link
              rel="icon"
              href="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-32x32.png"
              sizes="32x32"
            />
            <link
              rel="icon"
              href="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-192x192.png"
              sizes="192x192"
            />
            <link
              rel="apple-touch-icon-precomposed"
              href="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-180x180.png"
            />
            <meta
              name="msapplication-TileImage"
              content="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/6/2019/10/23094117/cropped-ggx-270x270.png"
            />
            <meta name="application-name" content="GOGOX" />
            <meta name="msapplication-TileColor" content="#0088bf" />
          </Helmet>
          <div>
            {showHeader && <OrderingHeader filename={this.state.pathname} />}
            <div className={s2.child}>{this.props.children}</div>
            {showFooter && <OrderingFooter />}
          </div>
        </div>
      );
    }
    return null;
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  defaultLocale: state.intl.defaultLocale,
  isDefaultLang: state.intl.isDefaultLang,
});
const mapDispatch = {
  setLocale,
  setIsdefaultLang,
};
export default connect(mapState, mapDispatch)(
  withStyles(normalizeCss, s, s2)(Layout),
);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js